import './Navbar.scss'
import '../../App.scss'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../store/Actions'
import { useNavigate } from 'react-router-dom'
import { FaRegBuilding } from 'react-icons/fa'
import { FiUser, FiLogIn, FiLogOut } from 'react-icons/fi'
import { GrDocumentText } from 'react-icons/gr'
import { BiCategoryAlt } from 'react-icons/bi'
import { LuMessageCircleMore } from 'react-icons/lu'
import { HiOutlineBuildingOffice2 } from 'react-icons/hi2'
import { NavDropdown } from 'react-bootstrap'
import WhiteLogo from '../../assets/images/logo-white.png'

export default function KonektoNavbar() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { token, userInfo } = useSelector(state => state.authentication)
  const { myCompany } = useSelector(state => state.company)

  const handleAuthClick = e => {
    if (token) {
      e.preventDefault()
      dispatch(logout()).then(logoutSuccess => {
        if (logoutSuccess) {
          navigate('/prijava')
        }
      })
    }
  }

  const handleAddEditCompanyClick = e => {
    if (token && myCompany) {
      navigate('/moja-firma')
      return
    }

    if (token) {
      navigate('/registracija-firme')
    } else {
      navigate('/registracija')
    }
  }

  return (
    <Navbar expand="lg" className={`navbar`} variant="dark">
      <Container fluid>
        <Navbar.Brand className={'logo'} onClick={() => navigate('/')}>
          <img src={WhiteLogo} />
        </Navbar.Brand>

        <Nav.Link
          className="text-center ms-3 d-none d-lg-flex"
          onClick={() => navigate('/kategorije')}>
          <div>
            <BiCategoryAlt className="fs-4" />
            <div>Kategorije</div>
          </div>
        </Nav.Link>

        <Nav.Link
          className="text-center ms-3 d-none d-lg-flex"
          onClick={() => navigate('/sve-firme')}>
          <div>
            <HiOutlineBuildingOffice2 className="fs-4" />
            <div>Sve firme</div>
          </div>
        </Nav.Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto text-center">
            <Nav.Link
              className="d-lg-none"
              onClick={() => navigate('/kategorije')}>
              <BiCategoryAlt />
              <div>Kategorije</div>
            </Nav.Link>

            <Nav.Link
              className="d-lg-none"
              onClick={() => navigate('/sve-firme')}>
              <HiOutlineBuildingOffice2 />
              <div>Sve firme</div>
            </Nav.Link>

            <Nav.Link onClick={() => navigate('/zahtjevi/start')}>
              <GrDocumentText />
              <div>Zahtjevi</div>
            </Nav.Link>

            {token ? (
              <Nav.Link onClick={() => navigate('/poruke')}>
                <LuMessageCircleMore />
                <div>Poruke</div>
              </Nav.Link>
            ) : null}

            <Nav.Link href={'#'} onClick={handleAddEditCompanyClick}>
              <FaRegBuilding />
              <div>{myCompany ? `Moja firma` : `Dodaj firmu`}</div>
            </Nav.Link>

            {/* <Nav.Link href={token ? '#' : '/prijava'} onClick={handleAuthClick}>
              {token ? <FiLogOut /> : <FiLogIn />}
              <div>{token ? 'Odjavi se' : 'Prijavi se'}</div>
            </Nav.Link> */}

            {token ? (
              <NavDropdown
                title={
                  <div className="d-flex flex-column align-items-center">
                    <FiUser />
                    <div className="user-name">
                      {userInfo?.first_name ?? 'Moj profil'}
                    </div>
                  </div>
                }
                id="basic-nav-dropdown"
                className="user-dropdown"
                align="end">
                {/* <NavDropdown.Item href="/moj-profil" className="d-link">
                  <FiUser className="me-2" />
                  Moj Profil
                </NavDropdown.Item> */}

                <NavDropdown.Divider />

                <NavDropdown.Item onClick={handleAuthClick} className="d-link">
                  <FiLogOut className="me-2" />
                  Odjavi se
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link onClick={() => navigate('/prijava')}>
                <FiLogIn />
                <div>Prijavi se</div>
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
